import { CART_MODULE } from "@/api_framework/api_config";
import { ICartDetailsResponse, ICartDetailsResponseData } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});

export const useCartDetailsForMirrorViewAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<ICartDetailsResponseData>(null);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (cartId: string, clinicId: string) => {
      try {
        dispatch(
          setLoading({
            key: "isCustomerCartMirrorTableInProgress",
            status: true,
          }),
        );

        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartDetailsResponseData | null = await axios
          .get(`${CART_MODULE?.CART_DETAILS_API_FOR_MIRROR?.baseURL}?cart_id=${cartId}&clinic_id=${clinicId}`, {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartDetailsResponse>) => {
            if (res.data.status === true) {
              setData(res.data.data);

              dispatch(
                setLoading({
                  key: "isCustomerCartMirrorTableInProgress",
                  status: false,
                }),
              );
              return res.data.data;
            } else {
              setData(null);
              dispatch(
                setLoading({
                  key: "isCustomerCartMirrorTableInProgress",
                  status: false,
                }),
              );
              return null;
            }
          })
          .catch((e: AxiosError) => {
            setData(null);
            sendCurl(e.config["curlCommand"]);

            dispatch(
              setLoading({
                key: "isCustomerCartMirrorTableInProgress",
                status: false,
              }),
            );
            return null;
          });
        return response;
      } catch (e) {
        setData(null);
        dispatch(
          setLoading({
            key: "isCustomerCartMirrorTableInProgress",
            status: false,
          }),
        );
      }
    },
    [dispatch],
  );
  return { data, execute };
};
